module.exports = __webpack_public_path__ + "static/media/features-iphone-2.149ca1fa.png";